import React, { useEffect } from "react";
import Header from "./header";
import Footer from "./footer";

function Layout({ children }) {

    useEffect(() => {
        // define a custom handler function
        // for the contextmenu event
        const handleContextMenu = (e) => {
            // prevent the right-click menu from appearing
            e.preventDefault();
        };

        // attach the event listener to
        // the document object
        document.addEventListener("contextmenu", handleContextMenu);

        // clean up the event listener when
        // the component unmounts
        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);

    return (
        <div>
            <Header/>
            {children}
            <Footer/>
        </div>
    );
}

export default Layout;
